<div [style.display]="state.value === 'inactive' ? 'none' : ''">
  <app-notification-item [notification]="notification"></app-notification-item>
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
